export type WebApp = 'FPNetJS' | 'FPNet' | 'HR' | 'Docs' | 'Stampe';

export interface IConfig {
    host: string, // es.'https://fpnet2.ericed.it'
    hostJS: string, // es.'https://fpnet2.ericed.it'
    backendJS: string, // es.'/FPNet2021'
    backendFPNet: string, // es.'/FPNet2021'
    backendHR: string, // es.'/FPNet2023'
    backendDocs: string, // es.'/Docs2022'
    backendStampe: string, // es.'/stampe-rest'
}

export class Config implements IConfig {
    public host: string;
    public hostJS: string;
    public backendJS: string;
    public backendFPNet: string;
    public backendHR: string;
    public backendDocs: string;
    public backendStampe: string;

    constructor(json: IConfig) {
        this.host = json.host;
        this.hostJS = json.hostJS;
        this.backendJS = json.backendJS;
        this.backendFPNet = json.backendFPNet;
        this.backendHR = json.backendHR;
        this.backendDocs = json.backendDocs;
        this.backendStampe = json.backendStampe;
    }

    /*static getInstance = () => {
        return getConfigInstance();
    }*/

    getWebApp(webApp: WebApp | undefined) {
        switch (webApp) {
            case 'FPNetJS':
                return this.backendJS
            case 'FPNet':
                return this.backendFPNet
            case 'HR':
                return this.backendHR
            case 'Docs':
                return this.backendDocs
            case 'Stampe':
                return this.backendStampe
            default:
                return ''
        }
    }

    // public getBaseUrl = (webApp?: WebApp) => (process.env.NODE_ENV === 'development' ? this.devHost : this.prodHost) + (webApp === 'FPNet' ? this.backendFPNet : (webApp === 'HR' ? this.backendHR : (webApp === 'Docs' ? this.backendDocs : '')));
    public getBaseUrl = (webApp?: WebApp) => {
        //return (process.env.NODE_ENV === 'development' ? this.devHost : this.prodHost) + this.getWebApp(webApp)
        if (webApp === "FPNetJS")
            return this.hostJS + this.getWebApp(webApp);
        else
            return this.host + this.getWebApp(webApp);
    };
}